var scrollNavInit;

(function($){
		
	const selectors = {
		navContainer: '[data-scroll-nav]',
	}
	
	scrollNavInit = function(){
		$(selectors.navContainer).each((i, el) => {
			new ScrollNav(el);
		});
	}
	
	class ScrollNav {
		constructor(element){
			this.nav = element;
			
			this.init();
			this.resize();
			this.bind();
			
			this.scroll();
			// this.checkBreakpoint();
			
			
		}
		init(){
			
			this.links = $('a[href^="#"]:not([href="#"])', this.nav);
			this.targets = [];
			this.links.each((i, link) => {
				var $target = $( $(link).attr('href') );
				if($target.length){
					var targetData = {
						el: $target.get(0),
						link: link,
						offset: $target.offset().top
					};
					
					if( $(targetData.link).attr('data-offset') !== undefined ){ 
						targetData.offset -= parseFloat( $(targetData.link).attr('data-offset') );
					}
					else if( document.headerHeightScrolled && $(targetData.link).attr('data-ignore-header') === undefined ){ 
						targetData.offset -= document.headerHeightScrolled;
					}
					
					this.targets.push(targetData);
				}
			});
			
			// console.log(this);
		}
		resize(){
			$(this.targets).each((i, targetData) => {
				
				targetData.offset = $(targetData.el).offset().top
				
				if( $(targetData.link).attr('data-offset') !== undefined ){ 
					targetData.offset -= parseFloat( $(targetData.link).attr('data-offset') );
				}
				else if( document.headerHeightScrolled && $(targetData.link).attr('data-ignore-header') === undefined ){ 
					targetData.offset -= document.headerHeightScrolled;
				}
			});
			
			this.targets.sort((a,b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0)); 

		}
		bind(){
			
			$(document).ready((e)=>{ this.resize(); });
			$(window).resize( (e) => { this.resize(); });
			
			$(window).scroll( (e) => { this.scroll(); });
			
			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });
			
			// $(window).on('changed.zf.mediaquery', (e) => { this.checkBreakpoint(); });
			
			$(this.links).click( (e) => { this.linkClicked( $(e.target).closest('a').get(0) ); })
		}
		
		scroll(){
			
			if( this.isScrolling ) return;
			
			const _this = this;
			var scrollOff = $(window).scrollTop();
			
			// console.log("#######");
			
			$(_this.targets).each((i, targetData) => {
				
				var is_active = scrollOff >= targetData.offset;
				
				// console.log(scrollOff, targetData, is_active);
				
				if( i == 0 && scrollOff < targetData.offset ) {
					is_active = true;
				}
				
				if( is_active ){
					// console.log(scrollOff, targetData.offset,  _this.targets[i+1].offset);
					// console.log('this active');
				}
				
				if( i < _this.targets.length -1 && scrollOff >= _this.targets[i+1].offset ) {
					// console.log('next active');
					is_active = false;
				}
				
				if( is_active ){
					$(targetData.link).addClass('is-active');
				}
				else {
					$(targetData.link).removeClass('is-active');
				}
				
			});
				
		}
		
		// checkBreakpoint(){
		// 	
		// 	if( Foundation.MediaQuery.atLeast('medium') ){
		// 		this.fixto.start();
		// 	}
		// 	else {
		// 		this.fixto.stop();
		// 	}
		// }
		
		linkClicked(link){
			
			if( ! $( $(link).attr('href') ).length ) return;
			
			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
			$(link).blur();
		}
		
	}

})(jQuery);
	
	
export default scrollNavInit;